import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import "../../../../../../formLayout.scss";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import {
  Link,
  Box,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Modal,
} from "@mui/material";

import {
  validateEmail,
  validateMobileNumber,
} from "../../../../../../Supporting files/HelpingFunction";
import RKTextField from "../../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../../../Supporting files/SelectDropdown/SelectDropdown";
import DatePicker from "../../../../../../Supporting files/DatePicker/DatePicker";
import MultipleSearchDropdown from "../../../../../../Supporting files/MultipleSearchDropdown/MultipleSearchDropdown";
import ModulePermissionAccessControl from "../../../../../../Components/Broker/ModulePermissionAccessControl/ModulePermissionAccessControl";
import RKTextFieldDisable from "../../../../../../Supporting files/RKTextFieldDisable/RKTextFieldDisable";
import SearchDropdownDisable from "../../../../../../Supporting files/SearchDropdownDisable/SearchDropdownDisable";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

function EditCreateUsers() {
  const navigate = useNavigate();
  const [fullName, setFullName] = React.useState("Vikas Saini");
  const [email, setEmail] = React.useState("Vikas.saini@evervent.in");
  const [role, setRole] = React.useState("Admin");
  const [branch, setBranch] = React.useState("Head Branch");
  const [Department, setDepartment] = React.useState("Designing");
  const [selectClient, setSelectClient] = React.useState("All");
  const [clientList, setClientList] = React.useState("");
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("userInformation");
  const [subSection, setSubSection] = React.useState<string>("basics");

  const role_data = [
    { label: "Admin", value: "Admin" },
    { label: "Member", value: "Member" },
    { label: "Super Admin", value: "Super Admin" },
    { label: "Custom", value: "Custom" },
  ];
  const branch_data = [
    { label: "Head Branch", value: "Head Branch" },
    { label: "Head Branch", value: "Head Branch" },
    { label: "Head Branch", value: "Head Branch" },
  ];
  const Department_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const clientList_data = [
    { key: "Vikas Saini", year: "Vikas Saini" },
    { key: "Rohit Manlotia", year: "Rohit Manlotia" },
    { key: "Umeh Gemini", year: "Umeh Gemini" },
    { key: "Kartike Kakkar", year: "Kartike Kakkar" },
    { key: "Vikas Saini", year: "Vikas Saini" },
    { key: "Rohit Manlotia", year: "Rohit Manlotia" },
    { key: "Umeh Gemini", year: "Umeh Gemini" },
    { key: "Kartike Kakkar", year: "Kartike Kakkar" },
    { key: "Vikas Saini", year: "Vikas Saini" },
    { key: "Rohit Manlotia", year: "Rohit Manlotia" },
    { key: "Umeh Gemini", year: "Umeh Gemini" },
    { key: "Kartike Kakkar", year: "Kartike Kakkar" },
  ];

  const selectClient_data = [
    {
      label: "Custom",
      value: "Custom",
    },
    { label: "All", value: "All" },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  // for scrolling
  const userInformation = useRef(null);
  const basics = useRef(null);
  const clientInfo = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate(-1);
            }}
          >
            <ChevronLeftIcon />
          </Link>

          <div>
            <h3>Edit Vikas Saini</h3>
          </div>
        </Grid>
        <Grid xs={6} sx={{ display: "flex", justifyContent: "end" }}>
          <Button className="updatePassword">
            <AdminPanelSettingsIcon /> Update Password
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection">
              <Link
                className={
                  sectionStatus === "userInformation"
                    ? "active sectionLink userInformation"
                    : "sectionLink userInformation"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(userInformation);
                  SetSectionStatus("userInformation");
                }}
              >
                <span> User Information</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "basics"
                        ? "inner_link active basics"
                        : "inner_link  basics"
                    }
                    onClick={() => {
                      handleClicks(subSection);
                      scrollToSection(basics);
                      setSubSection("basics");
                    }}
                  >
                    Basic Info
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      subSection === "clientInfo"
                        ? "inner_link active clientInfo"
                        : "inner_link clientInfo"
                    }
                    onClick={() => {
                      setSubSection("clientInfo");
                      handleClicks(subSection);
                      scrollToSection(clientInfo);
                    }}
                  >
                    Client Info
                  </Link>
                </li>
              </ul>
            </Grid>
            <Grid xs className="rightSection">
              <Box className="detailSection" ref={userInformation}>
                <div ref={basics}>
                  <div className="sectionTitle">
                    <h4>User Information</h4>
                  </div>
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <h5 className="subHeading">Basic Info</h5>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <RKTextFieldDisable
                        class_name="inputField"
                        title={"Full Name"}
                        value={fullName}
                        attrName={setFullName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <RKTextFieldDisable
                        class_name="inputField"
                        title={"Email"}
                        value={email}
                        attrName={setEmail}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>

                    <Grid sm={4} md={4} lg={3} xl={2}>
                      <SearchDropdownDisable
                        class_name="inputField"
                        title="Role"
                        value={role}
                        attrName={setRole}
                        value_update={updateMasterState}
                        data={role_data}
                        warn_status={false}
                        error_message="Please select Role"
                      />
                    </Grid>
                    <Grid sm={4} md={4} lg={3} xl={2}>
                      <SearchDropdownDisable
                        class_name="inputField"
                        title="Branch"
                        value={branch}
                        attrName={setBranch}
                        value_update={updateMasterState}
                        data={branch_data}
                        warn_status={false}
                        error_message="Please select Branch"
                      />
                    </Grid>
                    <Grid sm={6} md={5} lg={3} xl={3}>
                      <SearchDropdownDisable
                        class_name="inputField"
                        title="Department"
                        value={Department}
                        attrName={setDepartment}
                        value_update={updateMasterState}
                        data={Department_data}
                        warn_status={false}
                        error_message="Please select department"
                      />
                    </Grid>
                  </Grid>
                </div>
                <div ref={clientInfo}>
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <h5 className="subHeading">Client Info</h5>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid sm={6} md={5} lg={3} xl={3}>
                      <SearchDropdownDisable
                        class_name="inputField"
                        title="Select Client"
                        value={selectClient}
                        attrName={setSelectClient}
                        value_update={updateMasterState}
                        data={selectClient_data}
                        warn_status={false}
                        error_message="Please select client"
                      />
                    </Grid>
                    <Grid sm={6} md={5} lg={3} xl={3}>
                      <MultipleSearchDropdown
                        class_name="inputField"
                        title="Client List"
                        value={clientList}
                        attrName={setClientList}
                        value_update={updateMasterState}
                        multiple_data={clientList_data}
                      />
                    </Grid>
                  </Grid>
                </div>

                {role === "Custom" ? <ModulePermissionAccessControl /> : null}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Footer Section */}
      <Grid container spacing={3} className="footerSection">
        <Grid xs={12} className="ctaBtn">
          <Button variant="outlined" className="borderBtn">
            Cancel
          </Button>

          <Button
            variant="contained"
            className="submitBtn"
            onClick={() => {
              navigate(-1);
            }}
          >
            Save
          </Button>
        </Grid>
      </Grid>

      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are about to Delete this Attatchment.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
}

export default EditCreateUsers;
